// extracted by mini-css-extract-plugin
module.exports = {"narrowStyle":"a58_aux","link":"a58_gn","linkBrandColor":"a58_a59"};